import { render, staticRenderFns } from "./PackageShelf.vue?vue&type=template&id=cdbe15e8&scoped=true&"
import script from "./PackageShelf_.js?vue&type=script&lang=js&"
export * from "./PackageShelf_.js?vue&type=script&lang=js&"
import style0 from "./PackageShelf.vue?vue&type=style&index=0&id=cdbe15e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbe15e8",
  null
  
)

export default component.exports